import { Grid, Tooltip, Typography } from "@mui/material";

function ActiveArea({ areaInfo }) {
  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"row"}
        gap={"5px"}
        sx={{
          backgroundColor: "var(--emr-secondary)",
          minWidth: "200px",
          maxWidth: "200px",
          padding: "8px",
          borderRadius: "8px",
          overflow: "hidden",
        }}
        alignItems={"center"}
      >
        <Grid
          display={"flex"}
          flexDirection={"row"}
          sx={{ marginRight: "15px" }}
        >
          {areaInfo.groups?.map((group, index) => (
            <Tooltip key={index} title={group.name}>
              <img
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  marginRight: "-15px",
                  zIndex: areaInfo.groups.length - index,
                  border: "2px solid var(--emr-primary)",
                }}
                src={group.pic}
              />
            </Tooltip>
          ))}
        </Grid>
        <Typography variant="caption">{`${areaInfo.name} - ${areaInfo.areaOwner.name}`}</Typography>
      </Grid>
    </>
  );
}

export default ActiveArea;
